import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import CurrencyHelper from 'presentation/formatters/currency/index.js';

const classUtils = MojitoCore.Base.classUtils;
const { FlexPane, Image, Text } = MojitoPresentation.Components;

const TaxAbsorptionDisclaimer = ({ tax, currencyCode, mojitoTools, class: className }) => {
    const { stringResolver, config } = mojitoTools;
    const { hide, container, icon, text } = config;

    if (hide || tax === 0) {
        return null;
    }

    const formattedTax = CurrencyHelper.formatCurrency(tax, currencyCode);
    return (
        <FlexPane
            config={container}
            class={classUtils.classNames('ta-TaxAbsorptionDisclaimerContainer', className)}
        >
            <Image config={icon} class="ta-TaxAbsorptionDisclaimerIcon" />
            <Text config={text} class="ta-TaxAbsorptionDisclaimerText">
                {stringResolver.resolveAndFormatString(
                    '$TAX_ABSORPTION_DISCLAIMER.MESSAGE',
                    formattedTax
                )}
            </Text>
        </FlexPane>
    );
};

export default TaxAbsorptionDisclaimer;
